// Verbatim copy used by the trivia sharing UI. Centralized here so that
// ticket-mandated strings live in exactly one place and cannot drift between
// the multiple share entry points (TrivvySharingOptions, MessagesSharingOptions).

export const TEXT_ONLY_TAG_LABEL = "Most engaging and secure";
